export default __webpack_public_path__ + "static/media/web2.bd1f8d4e.png";